module.exports = __webpack_public_path__ + "static/media/c55.1c023f10.png";